<template>
  
  <div>

    <div id="create-user-dialog" class="ui large modal create-user-modal">

      <div class="ui header">
        Cadastro de usuário
      </div>

      <div v-if="customer" class="content modal-content-scrolling">

        <form class="ui form" @submit.prevent="onConfirm()">
          <div class="fields">
            <div class="sixteen wide field">
              <label class="form-label">Razão Social</label>
              <input type="text" :value="customer.name" readonly="readonly">
            </div>
          </div>          
          <div class="fields">
            <div class="eight wide field">
              <label class="form-label">CNPJ</label>
              <the-mask type="text" mask="##.###.###/####-##" :value="customer.cnpj" readonly="readonly" />
            </div>
            <div class="eight wide field">
              <label class="form-label">Nome <span class="red text">*</span></label>
              <input v-model="user.name">
            </div>
          </div>
          <div class="fields">
            <div class="eight wide field">
              <label class="form-label">Sobrenome <span class="red text">*</span></label>
              <input v-model="user.lastName">
            </div>
            <div class="eight wide field">
              <label class="form-label">E-mail <span class="red text">*</span></label>
              <input type="email" v-model="user.email">
            </div>
          </div>
          <div class="fields">
            <div class="eight wide field">
              <label class="form-label">Departamento <span class="red text">*</span></label>
              <input v-model="user.department">
            </div>
            <div class="eight wide field">
              <label class="form-label">Login <span class="red text">*</span></label>
              <input v-model="user.login">
            </div>
          </div>
          <div class="fields">
            <div class="eight wide field">
              <label class="form-label">Senha <span class="red text">*</span></label>
              <input type="password" v-model="user.password">
            </div>
            <div class="eight wide field">
              <label class="form-label">Confirmar senha <span class="red text">*</span></label>
              <input type="password" v-model="user.pswConf">
            </div>
          </div>
        </form>

      </div>

      <div class="actions">
        <button class="ui cancel basic button">
          <i class="times icon"></i>
          Cancelar
        </button>
        <button type="button" class="ui blue button" :class="{ loading: creating }" @click="onConfirm()">
          <i class="check icon"></i>
          Confirmar
        </button>
      </div>

    </div>

  </div>

</template>

<script>

  import { TheMask } from "vue-the-mask"
  import Message from "@/utils/message"
  import UserService from "@/services/user-service"

  export default {
    
    data() {
      return {
        creating: false,
        user: {},
      }      
    },

    props: ["customer"],

    components: { TheMask },

    beforeDestroy() {
      $(".create-user-modal").remove()
    },

    mounted() {

      this.initData()
    },

    methods: {

      initData() {

        this.creating = false

        this.user = {
          customer: null,
          group: null,
          name: "",
          lastName: "",
          email: "",
          department: "",
          login: "",
          password: "",
          pswConf: "",
        }
      },

      onConfirm() {
        
        if (this.validData())
          this.createUser()        
      },

      validData() {

        if (this.creating)
          return false

        let isOk = true
        let message = ""

        if (!this.user.name) {
          message = "Informe o nome"
        } else if (!this.user.lastName) {
          message = "Informe o sobrenome"
        } else if (!this.user.email) {
          message = "Informe o e-mail"
        } else if (!this.user.department) {
          message = "Informe o departamento"
        } else if (!this.user.login) {
          message = "Defina um login de acesso"
        } else if (!this.isValidLogin(this.user.login)) {
          message = "Login inválido"        
        } else if (!this.user.password) {
          message = "Defina uma senha"  
        } else if (!this.user.pswConf) {
          message = "Confirme a senha"    
        } else if (this.user.password !== this.user.pswConf) {
          message = "Senha não confirmada corretamente"      
        }

        if (message) {
          isOk = false
          Message.info(message)
        }

        return isOk
      },

      isValidLogin(login) {

        const regex = /^[a-zA-Z0-9.\-_]{1,50}$/
	
	      return regex.test(login)
      },

      async createUser() {

        this.creating = true

        try {

          this.user.customer = this.customer
          this.user.group = this.customer.isProspect ? "03" : "04"

          await UserService.create(this.user)

          $("#create-user-dialog").modal("hide")                              

          this.$emit("onCreate", this.$cloneObject(this.user))          

          this.initData()
          
        } catch (error) {
          
          this.creating = false
          this.$errorHandler(error)
        } 
      },
    },
  }
  
</script>

